module.exports = __webpack_public_path__ + "static/media/45986.3530c2a7.jpg";